import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormIndraComponent } from './date-form-indra.component';
import { ReactiveFormsModule } from '@angular/forms';
import {SelectInputIndraModule} from '@ibe.components/common/inputs/select-input-indra/select-input-indra.module';
import {IBEAdminModule} from '@ibe.components/shared/ibe-admin.module';

@NgModule({
  	declarations: [DateFormIndraComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		SelectInputIndraModule,
		IBEAdminModule
	],
  	exports: [DateFormIndraComponent]
})
export class DateFormIndraModule { }
